import { render } from "./PageManualView.vue?vue&type=template&id=304f7990"
import script from "./PageManualView.vue?vue&type=script&lang=js"
export * from "./PageManualView.vue?vue&type=script&lang=js"

import "./PageManualView.vue?vue&type=style&index=0&id=304f7990&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__